(function () {
    'use strict';

    var gettext = angular.identity;

    angular
        .module('app.associationAdmin')
        .constant('associationAdminResources', {
            reportRetrievalFailed: gettext('Failed to retrieve reports.'),
        });
})();
